module.exports = __webpack_public_path__ + "static/media/Tri-Seal.ff87f0e3.pdf";